export async function getCompanySettings(supabase) {
	const { data, error } = await supabase
		.from('company_settings')
		.select('*')
		.eq('id', 'global')
		.maybeSingle()
	if (error) {
		console.warn('getCompanySettings error:', error)
		return null
	}
	return data
}
